import React from 'react';
import PropTypes from 'prop-types';
import Link from '@welldev-group/rcl-link';
import './styles.scss';

const ExchangeHeaderItem = ({ label, text, href }) => (
  <div className="exchange-header-item">
    <span className="exchange-header-item__label">{label}</span>
    <span className="exchange-header-item__text">
      {href ? (
        <Link href={href} size="tiny" openNewTab={true} modifier="tertiary">
          {text}
        </Link>
      ) : (
        text
      )}
    </span>
  </div>
);

ExchangeHeaderItem.defaultProps = {
  href: '',
};

ExchangeHeaderItem.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  href: PropTypes.string,
};

export default ExchangeHeaderItem;
